import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataDocumentPresetsType } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_DOCUMENT_PRESETS_TYPE =
  defineMasterdataEntity<MasterdataDocumentPresetsType>({
    name: 'document-presets-type',
    responseKey: 'documentPresetsTypes',
    displayWith: (d) => keyName(d.key, d.documentType?.name),
    secondaryWith: (d) => d.tooltip,
    icon: 'fa-regular fa-file-lines',
    title: 'Erfassungsvariantensuche',
    label: 'Erfassungsvariante',
    placeholder: 'Erfassungsvariante suchen...',
    columns: [
      {
        label: 'Erfassungsvariante',
        type: 'entity',
        icon: 'fa-regular fa-file-lines',
        value: (e) => keyName(e.key, e.documentType?.name),
        secondary: (e) => e.tooltip,
      },
      { label: 'Schlüssel', type: 'text', value: (e) => e.key },
      {
        label: 'Belegart',
        type: 'text',
        value: (e) => e.documentType?.name ?? null,
      },
      { label: 'Tooltip', type: 'text', value: (e) => e.tooltip },
    ],
  });
